
import { AppUser } from '../../../core/security/model/app-user.model';

export interface ISessionState {
    isLoggedIn: boolean;
    currentUser: AppUser;
}

const initialState: ISessionState = {
    isLoggedIn: false,
    currentUser: null,
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/session/ISessionState.ts